import { createFileRoute } from "@tanstack/react-router";

import { EditTeamPage } from "@/features/teams/EditTeamPage.tsx";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/teams/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Edit Team");

  return <EditTeamPage />;
}
